import http from "./http_common";

class CarePlanService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  GetPatientTask(data) {
    var queryString = this.queryString(data);
    return http.get(`/patientTask/getPatientTaskDetails?${queryString}`);
  }

  GetPatientCreatedTask(data) {
    var queryString = this.queryString(data);
    return http.get(`/PatientCreatedTask/list?${queryString}`);
  }

  UpdateActivityStatus(data) {
    return http.post(`/PatientCreatedTask/`, data);
  }

  GetPatientMedication(data) {
    var queryString = this.queryString(data);
    return http.get(`PatientMedication/list/filter?${queryString}`);
  }
  GetPatientCreatedMedication(data) {
    var queryString = this.queryString(data);
    return http.get(`/PatientCreatedMedication/list/filter?${queryString}`);
  }

  UpdateMedicationStatus(data) {
    return http.post(`/PatientCreatedMedication/save`, data);
  }

  PatientRPMVitalsConfig(data) {
    var queryString = this.queryString(data);
    return http.get(`PatientVitalsConfig/list/filter?${queryString}`);
  }
}

export default new CarePlanService();
